import React, { useEffect, useState } from 'react';
import IncludeExcludeSelected from '../../components/IncludeExcludeSelected';
import { ReviewersSelectType } from '../../types';
import useGetRequest from '../../hooks/useGetRequest';
import { getOpinionFeedsReviewers } from '@/pages/opinion/services';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function ReviewersSelect({
  gameInfo,
  params,
  collectionCallback,
  ...props
}: ReviewersSelectType) {
  const [timeParams, setTimeParams] = useState<
    | {
        start_time: string;
        end_time: string;
        date_type: string;
      }
    | undefined
  >(undefined);

  const {
    loading,
    basicOptions,
    clearOptions,
    debounceGetFilterList,
    setLoading,
    changeBasicOptions,
  } = useGetRequest({
    gameInfo,
    timeParams,
    params,
    requestFunc: getOpinionFeedsReviewers,
    singleKey: 'search_content',
    multipleKey: 'reviewers',
  });

  useEffect(() => {
    collectionCallback?.('reviewers', (value: any) => setTimeParams(value), [
      'date',
    ]);
  }, []);

  return (
    <IncludeExcludeSelected
      changeBasicOptions={changeBasicOptions}
      clearOptions={clearOptions}
      loading={loading}
      setLoading={setLoading}
      basicOptions={basicOptions}
      getFilterList={debounceGetFilterList}
      resultKey={'reviewer'}
      includeKey="reviewers"
      excludeKey="exclude_reviewers"
      placeholderKey="reviewers"
      {...props}
      pointKey={FilterButtonPoint.reviewers}
    ></IncludeExcludeSelected>
  );
}
